import { useSyncExternalStore } from "react";
import { connectionStatus } from "@/api/connectionStatus/connectionStatus";

export const useConnectionStatus = (): boolean =>
  useSyncExternalStore(connectionStatus.subscribe, connectionStatus.getStatus);
